import React from 'react';
import { ReactComponent as TwitterIcon } from './bird.svg';

const twitterUpdatesData = {
	title: '',
	twitterIcon: <TwitterIcon />,
};

export default twitterUpdatesData;
